define('models/member/profile',[
    'services/i18n', 'underscore', 'backbone', 'moment', 'mustache', 'utils',
    // src
    'services/unit-converter',
    'services/user',
    'services/api',
    'services/session',
    //Collection
    'collections/member/supervisors',
    'collections/commons/locales',
    // parent
    'src/file-upload-model',
], function(
    i18n, _, Backbone, moment, Mustache, U,
    // services
    UnitConverter,
    User,
    API,
    Session,
    //collections
    Supervisors,
    CLocales,
    // parent
    FileUploadModel
) {

    var _isUndefined = _.isUndefined,
        floor = Math.floor,
        round = Math.round;

    var MProfile = FileUploadModel.extend({
        idAttribute: '_id',
        blacklist: ['group', 'displayName', 'points', 'tempPassword', 'picture'],
        files: ['picture'],

        urlRoot: function() {

            // to add a new user or move him to another group, use the group endpoint.
            // if (this.isNew() || this.has('_moveToGroup')) {
            // fetch user via group endpoint to get group related data like expiration
            var group = this.get('group');
            if (group) {
                return API.url(Mustache.render('groups/{{{groupId}}}/users/', {
                    groupId: _.isObject(group) ? group.id : group
                }));
            }

            return API.url("users");
        },
        defaults: {
            firstname: "",
            lastname: "",
            email: "",
            gender: "male",
            language: "",
            points: 0,
            password: "",
            tempPassword: "",
            phone: "",
            mainGroup: "",
            questionnaires: [],
            templates: [],
            customDataDefIds: [], // This contains a list of Custom Data Def Ids to show in the profile header
            _sendInvite: true,
            _isSupervisor: false,
            _expire: null,
            calorie_goal: null,
            disable_calorie_goal: false,
            isHiddenFromClientsList: true,
            favorite_exercises_type: 'both',
            firebaseToken: null,
            firebaseWebToken: null,
            zoomPersonalMeetingId: null,
            completedTutorials: [],
            showOnboarding: false,
            _disable_animated_sessions: false
        },
        computeds: {
            // DO NOT USE displayName
            name: {
                deps: ["firstname", "lastname"],
                get: function(firstname, lastname) {
                    return firstname + " " + lastname;
                }
            },

            age: {
                deps: ['birthdate'],
                get: function(birthdate) {
                    if (!birthdate) return null;
                    return moment().diff(birthdate, 'years');
                }
            },

            groupName: {
                deps: ["group"],
                get: function(group) {
                    return group ? group.name : null;
                }
            },
            thumbnail: {
                deps: ["picture"],
                get: function(picture) {
                    return picture ? picture.thumbnail : "assets/images/default-profile-pic-thumbnail.jpg";
                }
            },
            full: {
                deps: ["picture"],
                get: function(picture) {
                    return picture ? picture.full : "assets/images/default-profile-pic-thumbnail.jpg";
                }
            },
            relativeLastLoginDate: {
                deps: ["lastLoginDate"],
                get: function(lastLoginDate) {
                    return moment(lastLoginDate).fromNow();
                }
            },
            relativeLastActivityDate: {
                deps: ["lastPlannedActivityDate"],
                get: function(lastActivityDate) {
                    var retVal = moment(lastActivityDate).fromNow();

                    if (lastActivityDate === "1970-01-01") {
                        retVal = i18n.t('No activities found');
                    } else if (moment(lastActivityDate).isSame(moment(), 'day') === true) {
                          retVal = i18n.t('Last Activity today');
                        }

                    return retVal;
                }
            },
            lengthUnit: {
                deps: ["units"],
                get: function(units) {
                    return units ? units.length : null;
                },
                set: function(lengthUnit) {
                    var units = this.get('units') || {};
                    return {
                        units: MProfile.getUnitsObject(units.distance, lengthUnit, units.weight)
                    };
                }
            },
            distanceUnit: {
                deps: ["units"],
                get: function(units) {
                    return units ? units.distance : '-';
                },
                set: function(distanceUnit) {
                    var units = this.get('units') || {};
                    return {
                        units: MProfile.getUnitsObject(distanceUnit, units.length, units.weight)
                    };
                }
            },
            heightValue: {
                deps: ["height"],
                get: function(height) {
                    return height ? height.value : null;
                },
                set: function(value) {
                    var height = this.get('height') || {};
                    return {
                        height: MProfile.getHeightObject(height.unit, value)
                    };
                }
            },

            heightValueLabel: {
                deps: ["heightValue"],
                get: function(heightValue) {
                    return heightValue ? heightValue : 'N/A';
                },
            },

            heightUnit: {
                deps: ["height"],
                get: function(height) {
                    return height ? height.unit : 'cm';
                },
                set: function(unit) {
                    var height = this.get('height') || {};
                    return {
                        height: MProfile.getHeightObject(unit, height.value)
                    };
                }
            },

            weightUnit: {
                deps: ["units"],
                get: function(units) {
                    return units ? units.weight : null;
                },
                set: function(weightUnit) {
                    var units = this.get('units') || {};
                    return {
                        units: MProfile.getUnitsObject(units.distance, units.length, weightUnit)
                    };
                }
            },

            daysRemaining: {
                deps: ["_expire"],
                get: function(expire) {
                    var days = moment(expire).diff(moment().startOf('day'), 'days');
                    if (days < 0) days = 0;

                    return expire ? days : '∞';
                }
            },
            questionnaireEmail: {
                deps: ["emails"],
                get: function(emails) {
                    return emails ? emails.questionnaireCorrection : '-';
                },
                set: function(questionnaireEmail) {
                    var emails = this.get('emails') || {};
                    return {
                        emails: MProfile.getEmailsObject(emails.expire, emails.pm, questionnaireEmail, emails.weeklyRecap, emails.newQuestionnaire, emails.workoutReminder)
                    };
                }
            },
            weeklyRecapEmail: {
                deps: ["emails"],
                get: function(emails) {
                    return emails ? emails.weeklyRecap : '-';
                },
                set: function(weeklyRecapEmail) {
                    var emails = this.get('emails') || {};
                    return {
                        emails: MProfile.getEmailsObject(emails.expire, emails.pm, emails.questionnaireCorrection, weeklyRecapEmail, emails.newQuestionnaire, emails.workoutReminder)
                    };
                }
            },
            expireEmail: {
                deps: ["emails"],
                get: function(emails) {
                    return emails ? emails.expire : '-';
                },
                set: function(expireEmail) {
                    var emails = this.get('emails') || {};
                    return {
                        emails: MProfile.getEmailsObject(expireEmail, emails.pm, emails.questionnaireCorrection, emails.weeklyRecap, emails.newQuestionnaire, emails.workoutReminder)
                    };
                }
            },
            privateMessageEmail: {
                deps: ["emails"],
                get: function(emails) {
                    return emails ? emails.pm : '-';
                },
                set: function(privateMessageEmail) {
                    var emails = this.get('emails') || {};
                    return {
                        emails: MProfile.getEmailsObject(emails.expire, privateMessageEmail, emails.questionnaireCorrection, emails.weeklyRecap, emails.newQuestionnaire, emails.workoutReminder)
                    };
                }
            },
            newQuestionnaireEmail: {
                deps: ["emails"],
                get: function(emails) {
                    return emails ? emails.newQuestionnaire : '-';
                },
                set: function(newQuestionnaireEmail) {
                    var emails = this.get('emails') || {};
                    return {
                        emails: MProfile.getEmailsObject(emails.expire, emails.pm, emails.questionnaireCorrection, emails.weeklyRecap, newQuestionnaireEmail, emails.workoutReminder)
                    };
                }
            },
            workoutReminderEmail: {
                deps: ["emails"],
                get: function(emails) {
                    return emails ? emails.workoutReminder : '-';
                },
                set: function(workoutReminderEmail) {
                    var emails = this.get('emails') || {};
                    return {
                        emails: MProfile.getEmailsObject(emails.expire, emails.pm, emails.questionnaireCorrection, emails.weeklyRecap, emails.newQuestionnaire, workoutReminderEmail)
                    };
                }
            },
            clientEmptiedSessionsEmail: {
                deps: ["emailsSupervisor"],
                get: function(emailsSupervisor) {
                    return emailsSupervisor ? emailsSupervisor.clientEmptiedSessions : '-';
                },
                set: function(clientEmptiedSessionsEmail) {
                    var emailsSupervisor = this.get('emailsSupervisor') || {};
                    return {
                        emailsSupervisor: MProfile.getEmailsSupervisorObject(clientEmptiedSessionsEmail, emailsSupervisor.clientExpire, emailsSupervisor.clientRecap, emailsSupervisor.clientPostFeedback, emailsSupervisor.clientActivated, emailsSupervisor.clientAnswerQuestionnaire)
                    };
                }
            },
            clientExpireEmail: {
                deps: ["emailsSupervisor"],
                get: function(emailsSupervisor) {
                    return emailsSupervisor ? emailsSupervisor.clientExpire : '-';
                },
                set: function(clientExpireEmail) {
                    var emailsSupervisor = this.get('emailsSupervisor') || {};
                    return {
                        emailsSupervisor: MProfile.getEmailsSupervisorObject(emailsSupervisor.clientEmptiedSessions, clientExpireEmail, emailsSupervisor.clientRecap, emailsSupervisor.clientPostFeedback, emailsSupervisor.clientActivated, emailsSupervisor.clientAnswerQuestionnaire)
                    };
                }
            },
            clientRecapEmail: {
                deps: ["emailsSupervisor"],
                get: function(emailsSupervisor) {
                    return emailsSupervisor ? emailsSupervisor.clientRecap : '-';
                },
                set: function(clientRecapEmail) {
                    var emailsSupervisor = this.get('emailsSupervisor') || {};
                    return {
                        emailsSupervisor: MProfile.getEmailsSupervisorObject(emailsSupervisor.clientEmptiedSessions, emailsSupervisor.clientExpire, clientRecapEmail, emailsSupervisor.clientPostFeedback, emailsSupervisor.clientActivated, emailsSupervisor.clientAnswerQuestionnaire)
                    };
                }
            },
            clientPostFeedbackEmail: {
                deps: ["emailsSupervisor"],
                get: function(emailsSupervisor) {
                    return emailsSupervisor ? emailsSupervisor.clientPostFeedback : '-';
                },
                set: function(clientPostFeedbackEmail) {
                    var emailsSupervisor = this.get('emailsSupervisor') || {};
                    return {
                        emailsSupervisor: MProfile.getEmailsSupervisorObject(emailsSupervisor.clientEmptiedSessions, emailsSupervisor.clientExpire, emailsSupervisor.clientRecap, clientPostFeedbackEmail, emailsSupervisor.clientActivated, emailsSupervisor.clientAnswerQuestionnaire)
                    };
                }
            },
            clientActivatedEmail: {
                deps: ["emailsSupervisor"],
                get: function(emailsSupervisor) {
                    return emailsSupervisor ? emailsSupervisor.clientActivated : '-';
                },
                set: function(clientActivatedEmail) {
                    var emailsSupervisor = this.get('emailsSupervisor') || {};
                    return {
                        emailsSupervisor: MProfile.getEmailsSupervisorObject(emailsSupervisor.clientEmptiedSessions, emailsSupervisor.clientExpire, emailsSupervisor.clientRecap, emailsSupervisor.clientPostFeedback, clientActivatedEmail, emailsSupervisor.clientAnswerQuestionnaire)
                    };
                }
            },
            clientAnswerQuestionnaireEmail: {
                deps: ["emailsSupervisor"],
                get: function(emailsSupervisor) {
                    return emailsSupervisor ? emailsSupervisor.clientAnswerQuestionnaire : '-';
                },
                set: function(clientAnswerQuestionnaireEmail) {
                    var emailsSupervisor = this.get('emailsSupervisor') || {};
                    return {
                        emailsSupervisor: MProfile.getEmailsSupervisorObject(emailsSupervisor.clientEmptiedSessions, emailsSupervisor.clientExpire, emailsSupervisor.clientRecap, emailsSupervisor.clientPostFeedback, emailsSupervisor.clientActivated, clientAnswerQuestionnaireEmail)
                    };
                }
            },
            uncompletedExerciseNotification: {
                deps: ["pushNotifications"],
                get: function(pushNotifications) {
                    return pushNotifications ? pushNotifications.uncompletedExercise : '-';
                },
                set: function(uncompletedExerciseNotification) {
                    var pushNotifications = this.get('pushNotifications') || {};
                    return {
                        pushNotifications: MProfile.getPushNotificationObject(uncompletedExerciseNotification, pushNotifications.newActivityCreated)
                    };
                }
            },
            newActivityCreatedNotification: {
                deps: ["pushNotifications"],
                get: function(pushNotifications) {
                    return pushNotifications ? pushNotifications.newActivityCreated : '-';
                },
                set: function(newActivityCreated) {
                    var pushNotifications = this.get('pushNotifications') || {};
                    return {
                        pushNotifications: MProfile.getPushNotificationObject(pushNotifications.uncompletedExercise, newActivityCreated)
                    };
                }
            },
            logoUrl: {
                deps: ['logo'],
                get: function(logo) {
                    return logo && logo.type !== "text" ? logo.data : "";
                },
            },
            logoData: {
                deps: ['logo'],
                get: function(logo) {
                    return logo ? logo.data : "assets/images/yourlogo.png";
                },
            },
            logoType: {
                deps: ['logo'],
                get: function(logo) {
                    return logo ? logo.type : "image";
                },
            },

            brandColor: {
                deps: ['backgroundColor'],
                get: function(color) {
                  //if invalid color, default blue TC
                  if (!/^#[0-9A-F]{6}$/i.test(color)) {
                    color = '#00adef';
                  }
                    return color ? color : "#00adef";
                }
            },

            customButtonText: {
                deps: ['customButton'],
                get: function(button) {
                    return button ? button.text : "";
                },
            },
            customButtonUrl: {
                deps: ['customButton'],
                get: function(button) {
                    return button ? button.url : "";
                },
            },
            customButtonActive: {
                deps: ['customButton'],
                get: function(button) {
                    return button ? button.active : false;
                },
            },

            computedLanguage: {
                deps: ['language'],
                get: function() {
                    var locales = new CLocales();
                    var self = this;
                    var userLocale = locales.models.find(function(locale) {
                        return self.get('language') === locale.get('id');
                    });

                    if (userLocale) {
                        return i18n.t('languages:' + userLocale.get('label'));
                    }
                }
            },

            languageCode: {
                 deps: ["language", "country"],
                 get: function(language, country) {
                    if (language != null && language.length > 0) {
                        return language.substring(0, 2) + "-" + country;
                    } else {
                        return "";
                    }
                 }
             },

        },

        initialize: function(attrs, opt) {
            opt = opt || {};
            if (opt.group) this.setGroup(opt.group);

            this.readyPromise = Backbone.$.Deferred();
        },

        save: function(attrs, opt) {
            if (this.isNew()) {
                this.attributes = _.omit(this.attributes, 'mainGroup');
            }
            return MProfile.__super__.save.call(this, attrs, opt);
        },

        // parse: function(data, options) {
        //     if (data.birthdate != null) {
        //         var birthdate = data.birthdate = API.formatDate(data.birthdate);
        //         data.age = moment().diff(birthdate, 'years');
        //     }
        //
        //     return data;
        // },

        setGroup: function(group) {
            this.set('group', group);
        },

        moveToGroup: function(groupModel) {
            if (!groupModel.is(this.get('group'))) {
                this.set({ _moveToGroup: groupModel.id });
            } else {
                this.unset("_moveToGroup");
            }

        },

        getMainGroupId: function() {
            return this.get('_mainGroupId');
        },

        getMainGroup: function() {
            return this.get('_mainGroup');
        },

        getSupervisorGroup: function() {
            return this.get('_supervisorGroup');
        },

        getAllGroup: function() {
            return this.get('_groups');
        },

        addQuestionnaire: function(questionnaireId) {
            this.get('questionnaires').push(questionnaireId);
        },

        isMemberOfActiveGroup: function() {
            var groups = this.get('_groups');

            if (groups) {
                for (var i = 0; i < groups.length; ++i) {
                    if (groups[i].isActive === true) {
                        return true;
                    }
                }
            }

            return false;
        },

        needPaymentCenter: function() {
            return this.get("needPaymentCenter");
        },

        isMemberOfExpiredGroup: function() {
            var groups = this.get('_groups'),
                hasExpireGroup = false,
                hasActiveGroup = false;
            //false, expiredInAllGroup, expiredInAGroupButActiveInOne
            if (groups) {
                for (var i = 0; i < groups.length; ++i) {
                    if (groups[i].isActive === false) {
                        hasExpireGroup = true;
                    } else {
                        hasActiveGroup = true;
                    }
                }
            }

            if (hasActiveGroup === true && hasExpireGroup === true) {
                return "expiredInAGroupButActiveInOne";
            } else if (hasActiveGroup === false && hasExpireGroup === true) {
                  return "expiredInAllGroup";
            } else {
                return false;
            }
        },

        isExpiredFromGroup: function() {
            var groups = this.get('_groups');

            if (groups) {
                for (var i = 0; i < groups.length; ++i) {
                    if (moment().diff(moment(groups[i].expires)) > 0) {
                        return true;
                    }
                }
            }

            return false;
        },

        getLastActivityId: function() {
            return this.get('_lastActivityId');
        },

        isLogoImage: function() {
            return this.get('logoType') === "image";
        },

        isLogoText: function() {
            return this.get('logoType') === "text";
        },

        isSupervisor: function() {
            return this.get('_supervisor');
        },

        isAdmin: function() {
            return this.get('_isAdmin');
        },

        isMovingGroup: function() {
            return this.has('_moveToGroup');
        },

        isActive: function() {
            return this.get('isActive');
        },

        isBeta: function() {
            return this.get('_beta');
        },

        canManagePayments: function() {
            return this.get('needPaymentCenter');
        },

        getBrandColor: function() {
            var brandColor = this.get('brandColor');

            //if invalid color, default blue TC
            if (!/^#[0-9A-F]{6}$/i.test(brandColor)) {
              brandColor = '#00adef';
            }

            return brandColor;
        },

        markTutorialAsCompleted: function(tutorialId) {
            var tutorials = this.get('completedTutorials');
            this.save({ completedTutorials: tutorials.concat(tutorialId) }, { patch: true });
        },

        getIntercomAttributes: function() {
            var mainGroup = this.getMainGroup();
            return {
                app_id: window.env.INTERCOM_API_KEY,
                name: this.get('name'),
                firstname: this.get('firstname'),
                lastname: this.get('lastname'),
                email: this.get('email'),
                user_id: this.id,
                user_admin: this.getAdminLink(),
                isSupervisor: mainGroup.isSupervisor,
                main_group_id: mainGroup._id,
                main_group_name: mainGroup.name,
                main_group_admin: this.getGroupAdminLink(),
                expiry_date: moment(mainGroup.expires).unix(),
                package_name: this.get('package'),
                has_payment_method: this.get('has_payment_method')
            };
        },

        zoomMeetingUrl: function() {
            if (!this.get('zoomPersonalMeetingId')) {
                return null;
            }

            return 'https://zoom.us/j/' + this.get('zoomPersonalMeetingId');
        },

        getAdminLink: function() {
            return Mustache.render(window.env.OLD_ORIGIN + 'admin/members/edit.php?id={{{id}}}', { id: this.id });
        },

        getGroupAdminLink: function() {
            return Mustache.render(window.env.OLD_ORIGIN + 'admin/teams/edit.php?id={{{id}}}', { id: this.getMainGroup()._id });
        },

        fetch: function(opt) {
            opt = opt || {};
            var promise = this.ready();
            return MProfile.__super__.fetch.call(this, opt).then(
                function() {
                    promise.resolve();
                },
                function() {
                    promise.reject();
                });
        },

        getDefaultCalorieGoal: function() {
          return this.get('gender') === "male" ? 2500 : 2000;
        },

        getWeightValue: function(unit) {
            var weightUnit = this.get('weightUnit'),
                factor = 1;

            if (weightUnit !== unit) {
                if (unit === 'lbs') factor = 2.20462;
                else if (unit === 'kg') factor = 0.453592;
            }

            return this.get('_lastWeight').value * factor;
        },

        convertCmToInch: function() {
            var heightValue = this.get('heightValue'),
                feet = heightValue / 30.48,
                decimal = feet - floor(feet),
                inch = round(decimal * 12);
            feet = floor(feet);

            this.set('heightValue', feet * 12 + inch);

            return { feet: feet, inch: inch };
        },

        convertHeightTo: function(unit) {
            if (unit === 'in') {
                return this.convertCmToInch();
            } else {
                this.convertInchToCm();
            }
        },

        convertInchToCm: function() {
            var heightValue = this.get('heightValue');

            var cm = round(heightValue / 0.39370);
            this.set('heightValue', cm);
        },

        convertDistanceTo: function(startUnit, value, endUnit) {
            var endValue = 0;

            if (startUnit === 'miles') startUnit = 'mi';
            if (endUnit === 'miles') endUnit = 'mi';

            if (startUnit === 'km' && (endUnit === 'miles' || endUnit === 'mi')) {
              endValue = value * 0.621371;
            } else if ((startUnit === 'miles' || startUnit === 'mi') && endUnit === 'km') {
                endValue = value * 1.60934;
            } else if (startUnit === endUnit) {
              endValue = value;
            }

            return Math.round(endValue * 10) / 10;
        },

        convertInchToFeetAndInches: function() {
            var heightValue = this.get('heightValue');
            var feet = floor(heightValue / 12);
            var inch = floor(heightValue % 12);

            return { feet: feet, inch: inch };
        },

        getFeedback: function() {
            return this.get('_feedbackLevel');
        },

        isFromCanada: function() {
            return this.get('country') === 'CA';
        },

        getActivationDate: function() {
            return this.get('activationDate');
        },

        /**
         * Return a promise that resolves (or rejects) when a
         * sync is done.
         * @return {Deferred} promise of id loaded.
         */
        ready: function() {
            return this.readyPromise;
        },

        isReady: function() {
            return this.readyPromise.state() === "resolved";
        },

        validation: {
            firstname: {
                presence: true,
            },
            // lastname: {
            //     presence: true,
            // },
            email: {
                presence: true,
                email: true,
            },

        },

    }, {
        getHeightObject: function(unit, value) {
            return {
                unit: _isUndefined(unit) ? null : unit,
                value: _isUndefined(value) ? null : value,
            };
        },

        getUnitsObject: function(distance, length, weight) {
            return {
                distance: _isUndefined(distance) ? null : distance,
                length: _isUndefined(length) ? null : length,
                weight: _isUndefined(weight) ? null : weight,
            };
        },

        getEmailsObject: function(expire, pm, questionnaire, weeklyRecap, newQuestionnaire, workoutReminder) {
            return {
                expire: _isUndefined(expire) ? null : expire,
                pm: _isUndefined(pm) ? null : pm,
                questionnaireCorrection: _isUndefined(questionnaire) ? null : questionnaire,
                weeklyRecap: _isUndefined(weeklyRecap) ? null : weeklyRecap,
                newQuestionnaire: _isUndefined(newQuestionnaire) ? null : newQuestionnaire,
                workoutReminder: _isUndefined(workoutReminder) ? null : workoutReminder,
            };
        },

        getPushNotificationObject: function(uncompletedExercise, newActivityCreated) {
            return {
                uncompletedExercise: _isUndefined(uncompletedExercise) ? null : uncompletedExercise,
                newActivityCreated: _isUndefined(newActivityCreated) ? null : newActivityCreated,
            };
        },
        getEmailsSupervisorObject: function(clientEmptiedSessions, clientExpire, clientRecap, clientPostFeedback, clientActivated, clientAnswerQuestionnaire) {
            return {
                clientEmptiedSessions: _isUndefined(clientEmptiedSessions) ? null : clientEmptiedSessions,
                clientExpire: _isUndefined(clientExpire) ? null : clientExpire,
                clientRecap: _isUndefined(clientRecap) ? null : clientRecap,
                clientPostFeedback: _isUndefined(clientPostFeedback) ? null : clientPostFeedback,
                clientActivated: _isUndefined(clientActivated) ? null : clientActivated,
                clientAnswerQuestionnaire: _isUndefined(clientAnswerQuestionnaire) ? null : clientAnswerQuestionnaire,
            };
        },
    });

    return MProfile;
});

